// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-view-application-location-sn) {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.toolbar-headings {
  margin-left: 57.5px;
  justify-content: space-between;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: -0.0960779px;
  width: 170px;
}

.toolbar-headings {
  margin-left: 57.5px;
  justify-content: space-between;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: -0.0960779px;
  width: 170px;
}

.menu-item-text {
  color: #B2B2B2;
  font-weight: 600;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.083333px;
}

.active-heading {
  color: var(--theme-active-color, #243391);
}

.sidebar {
  mix-blend-mode: normal;
  background-color: rgba(234, 234, 234, 0.29);
  width: 200px;
  flex-basis: 200px;
  min-width: 200px;
}

.map {
  margin-right: 10px;
}

.map-row {
  min-height: 37vh;
  max-height: 70vh;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.remove-button {
  margin-left: 10px;
}

.last-row {
  margin-top: 5px;
  margin-bottom: 5px;
}

.div-margin {
  margin-bottom: 0px;
}

.missing-zones-label {
  font-size: 13px;
  color: #000000;
  padding: 0;
}

.greyed-out {
  background-color: #e9ecef;
}

.text-adjustment {
  width: 101%;
}

.table-alignment {
  width: 101%;
}

.input-alignment {
  margin-left: -1%;
  width: 51%;
}

.map-alignment {
  padding-right: -1%;
}

.align-map {
  padding-right: 10.5px;
  padding-left: 4px;
}

.tab-move {
  padding-left: 4px;
}

.input-outer {
  padding-left: 4px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
